import { Navigate, Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../context/authContext";

const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  const publicRoutes = [
    "/",
    "/unauthorized",
    "/request-password",
    "/verify-password",
    "/reset-password",
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-gray-600">Cargando...</p>
      </div>
    );
  }

  if (!user && !publicRoutes.includes(location.pathname)) {
    return <Navigate to="/" />;
  }

  return (
    <div className="flex flex-col min-h-screen min-w-[1600px]">
      <Navbar />
      <main className="flex-grow bg-gray-100 p-4">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default ProtectedLayout;

